module.exports = __webpack_public_path__ + "static/media/village_page12.edf6cf47.png";